/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, no-unused-vars, warp-drive/no-legacy-request-patterns */
// Extends From
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { alias } from '@ember/object/computed';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
// Internal Imports
import config from 'linced-app/config/environment';
import Scope from '@linc-technologies/linced-common/enums/scopes';
import SyncStep from '@linc-technologies/linced-common/enums/sif-au-sync-step';

export default class TeRitoController extends Controller {
  @service
  fetch;

  @service
  session;

  @service
  router;

  @service
  toaster;

  Scope = Scope;
  SyncStep = SyncStep;

  @alias('model.connection')
  connection;

  @alias('connection.syncEnabled')
  syncEnabled;

  @computed('connection.refId')
  get state() {
    return this.get('connection.refId')
      ? 'Complete'
      : 'Pending (Te Rito is connecting you)';
  }

  @tracked
  syncing = false;
  @tracked
  showSyncEnableDialog = false;

  async doSync(url) {
    this.syncing = true;
    let data = {
      schoolId: this.session.activeSchool,
    };
    try {
      await this.fetch.post(url, { data });
    } catch (e) {
      this.toaster.error(`Error synchronising data with Te Rito`);
    }
    this.syncing = false;
  }

  @action
  onSyncToggle(value) {
    if (value) {
      this.showSyncEnableDialog = true;
    } else {
      this.setParam('syncEnabled', value);
    }
  }

  @action
  confirmEnableSync() {
    this.showSyncEnableDialog = false;
    this.setParam('syncEnabled', true);
  }

  @action
  cancelEnableSync() {
    this.showSyncEnableDialog = false;
  }

  @action
  setParam(key, value) {
    this.connection.set(key, value);
    this.connection
      .save()
      .then(() => {
        this.toaster.success('Connection saved successfully.');
      })
      .catch(() => {
        this.toaster.error('Error saving connection!');
      });
  }

  @action
  async doPush() {
    let url = `${config.APP.apiHost}/providers/nz/te-rito/${config.APP.apiPath}/sync-up:start`;
    await this.doSync(url);
  }

  @action
  async doPull() {
    let url = `${config.APP.apiHost}/providers/nz/te-rito/${config.APP.apiPath}/sync-down:start`;
    await this.doSync(url);
  }
}
